import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { httpClient } from "../utils/http-client";
import { useContextValue } from "../context/LoaderContext";

const useApi = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${token}`,
    }),
    [token]
  );
  const { setLoading } = useContextValue();



  const handleApiError = useCallback((error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('isLogin')
      localStorage.removeItem('login')
      localStorage.removeItem('token')
      localStorage.removeItem('UserRole')
      localStorage.removeItem('userData')
      localStorage.removeItem('deviceData');
      navigate('/') // Automatically logout on token expiration
    }
    setError(error);
    setLoading(false);
    throw error;
  }, [navigate, setLoading]);


  const getData = useCallback(async (url, id, loader = true) => {
    setLoading(loader);
    setError(null);
    try {
      const requestUrl = id ? `${url}?id=${id}` : url;
      const response = await httpClient.get(requestUrl, { headers });
      setLoading(false);
      return response?.data;
    } catch (error) {
      handleApiError(error);
    }
  }, [handleApiError, headers, setLoading]);

  const postData = useCallback(async (url, data, redirectUrl = null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await httpClient.post(url, data, { headers });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, headers, navigate, setLoading]);

  const putData = useCallback(async (url, data, redirectUrl = null) => {
    setLoading(true);
    setError(null);
    try {
      const requestUrl = url;
      const response = await httpClient.put(requestUrl, JSON.stringify(data), {
        headers,
      });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, headers, navigate, setLoading]);

  const patchData = useCallback(async (url, data, redirectUrl = null) => {
    setLoading(true);
    setError(null);
    try {
      const response = await httpClient.patch(url, data, { headers });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, headers, navigate, setLoading]);

  const deleteData = useCallback(async (url, redirectUrl = null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await httpClient.delete(url, { headers });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response?.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, headers, navigate, setLoading]);
  const postFileData = useCallback(async (url, data, redirectUrl = null) => {
    setLoading(true);
    setError(null);
    try {
      const response = await httpClient.post(url, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response?.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, navigate, setLoading, token]);

  const gpsiottoken = useCallback(async (url, data, redirectUrl = null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await httpClient.post(url, data, {
        headers: {
          // Authorization: `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, navigate, setLoading]);
  const getDataDevice = useCallback(async (url, token_dv) => {
    setLoading(true);
    setError(null);
    try {
      const requestUrl = url;
      const response = await httpClient.get(requestUrl, {
        headers: {
          Authorization: `Bearer ${token_dv}`,
          "Content-Type": "application/json",
        },
      });
      setLoading(false);
      return response?.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, setLoading]);
  const postDataDevice = useCallback(async (url, data, token_dv, redirectUrl = null) => {
    setLoading(true);
    setError(null);

    try {
      const response = await httpClient.post(url, data, {
        headers: {
          Authorization: `Bearer ${token_dv}`,
          "Content-Type": "application/json",
        },
      });
      setLoading(false);
      if (redirectUrl) {
        navigate(redirectUrl);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);

    }
  }, [handleApiError, navigate, setLoading]);
  return useMemo(
    () => ({
      getData,
      postData,
      putData,
      patchData,
      deleteData,
      error,
      postFileData,
      gpsiottoken,
      postDataDevice,
      getDataDevice,
    }),
    [
      deleteData,
      error,
      getData,
      getDataDevice,
      gpsiottoken,
      patchData,
      postData,
      postDataDevice,
      postFileData,
      putData,
    ]
  );
};

export default useApi;
